module.exports = __webpack_public_path__ + "static/media/logo-pagseguro.adcbca67.png";